<template>
  <v-dialog
    width="auto"
    title="View Comments"
    :visible.sync="dialogVisible"
    :scrollbar="false"
    v-on="$listeners"
    @closed="onClosed"
    @open="onOpen"
  >
    <ul class="comments-list">
      <template v-if="loading">
        <Loading color="#d52b1e" />
      </template>
      <template v-else>
        <template v-if="comments.length > 0">
          <li class="comment-item" v-for="(item, i) in comments" :key="i">
            <p class="comment-item-info">
              <span>{{ item.SEName }}</span>
              <span>{{ item.CommentedOn }}</span>
            </p>
            <p>
              {{ item.Comment }}
            </p>
          </li>
        </template>
        <div class="empty-tips" v-else>No comment information</div>
      </template>
    </ul>
  </v-dialog>
</template>
<script>
import Loading from "../../../components/loading.vue";
export default {
  name: "view-comment-dialog",
  components: { Loading },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: false,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: true,
      comments: [],
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onClosed() {
      this.comments = [];
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
    },
    onOpen() {
      if (this.data) {
        this.getcomment();
      }
    },
    getcomment() {
      this.loading = true;
      this.axios
        .get("/seDetail/getcomment", {
          params: {
            seId: this.data.SEID,
            paperId: this.data.PaperID,
          },
        })
        .then(({ code, data }) => {
          if (code === 200) {
            this.comments = data;
          } else {
            this.comments = [];
            this.$message.error("Get comment failed");
          }
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    max-width: 65vw;
    min-width: 40vw;
  }
  .el-form-item__label {
    color: #555;
    font-weight: bold;
  }
  .el-dialog__footer {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0px 15px 15px;
  }
}
.comments-list {
  min-height: 120px;
  padding: 15px;
  .comment-item {
    position: relative;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    color: #303133;
    transition: 0.3s;
    padding: 15px;
    &::before,
    &::after {
      content: " ";
      border: 15px solid transparent;
      border-right: 15px solid #fff;
      position: absolute;
      width: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }
    &::before {
      left: -30px;
      border-right-color: #ebeef5;
    }
    &::after {
      left: -29px;
      border-right-color: #ffffff;
    }
    p + p {
      margin-top: 5px;
    }
    .comment-item-info {
      display: flex;
      justify-content: space-between;
      span {
        &:first-child {
          font-weight: bold;
        }
        &:last-child {
          color: #82848a;
        }
      }
    }
  }
  ::v-deep {
    .el-loading-mask {
      position: relative !important;
      .el-loading-spinner {
        margin-top: 0 !important;
      }
    }
  }
  .empty-tips {
    text-align: center;
    line-height: 80px;
  }
}
</style>